module.exports = __webpack_public_path__ + "img/pdf-label-fr.de08a0c4.jpg";